import { Identifiers, SectionsKey } from '~/constants/enum';

const PageStruct = {
    id: 'cart',
    useLayout: true,
    children: [
        { id: SectionsKey.Cart, order: 1 },
        { id: SectionsKey.Related, order: 2, dataKey: SectionsKey.Related },
        { id: SectionsKey.BenefitsSection, order: 3, identifier: Identifiers.BenefitsSection },
        { id: SectionsKey.FollowUs, order: 4, identifier: Identifiers.FollowUs }
    ]
};

export default PageStruct;
